// extracted by mini-css-extract-plugin
module.exports = {"form__submit":"Filters_form__submit__1FOGO","form__search":"Filters_form__search__1cajZ"};